// extracted by mini-css-extract-plugin
module.exports = {"feed":"home_feed__2z5mw","content":"home_content__34JfZ","loader":"home_loader__3Ya0B"};